import { BaseHttpClient } from '@/modules/common/services/http/__deprecated__/base-http-client';
import { IReferralTriggerIndication } from './types';

const referralApiUrl = '/v1/referral';

export class ReferralAPI extends BaseHttpClient {
  constructor() {
    super(undefined, process.env.VUE_APP_REFERRAL_API_URL);
  }

  public getTriggerIndication(portfolioId: string) {
    return this.get<IReferralTriggerIndication>(
      `${referralApiUrl}/trigger-indication`,
      { params: { portfolioId } }
    );
  }
}
